module.exports = __webpack_public_path__ + "static/solidarity-labs-1-27dacbf074fa760eac74b9d779527d9a.jpg";